import React from 'react';
import { UseFieldArrayReturn, useFormContext } from 'react-hook-form';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { FormFields } from '../../../AccountPreferences/components/AccountForm/AccountForm.meta';
import { AccountHoldingDTO } from '../../../../api/useAccountsQuery';

interface Props {
  clientId: number;
  holdingId: string;
  onClose(): void;
  holdingsArrayFormBag: UseFieldArrayReturn<FormFields, 'bankAccount.Positions', 'key'>;
}

export const DeleteHoldingModal = ({ holdingId, onClose, holdingsArrayFormBag }: Props) => {
  const { setValue } = useFormContext();

  const { fields: holdings, remove: removeHolding } = holdingsArrayFormBag;

  const onDelete = () => {
    const holdingIndexToBeDeleted = holdings.findIndex(({ Id }) => Id === holdingId);

    const newHoldings = holdings.filter(holding => holding.Id !== holdingId) as AccountHoldingDTO[];

    const specificPositionsValue = newHoldings.reduce(
      (acc, { Quantity, Price }) => acc + Quantity * Price,
      0,
    );

    setValue('bankAccount.SpecificPositionsValue', specificPositionsValue);

    removeHolding(holdingIndexToBeDeleted);

    onClose();
  };

  return (
    <Modal isOpen onRequestClose={onClose} aria={{ labelledby: 'delete-holding--modal-header' }}>
      <ModalHeader as="h2" id="delete-holding--modal-header">
        Are you sure you want to delete this holding?
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button onClick={onDelete} ml="12" variant="error">
          Delete Holding
        </Button>
      </ModalFooter>
    </Modal>
  );
};
